<template>
    <!-- 缩略图 -->
    <el-dialog v-if="isImgZoom" class="m-dialog imgZoom" :visible.sync="isShow" :width="width" :fullscreen="fullscreen" :top="top" :modal="modal" :show-close="false" :center="center" :lock-scroll="lockScroll" :close-on-click-modal="true" :close-on-press-escape="true" :before-close="onBeforeClose">
        <div ref="content"></div>
    </el-dialog>
    <!-- 普通弹窗 -->
    <el-dialog v-else :title="title" class="m-dialog yd-operate-model new-model" :visible.sync="isShow" :width="width" :fullscreen="fullscreen" :top="top" :modal="modal" :show-close="showClose" :center="center" :lock-scroll="lockScroll" :close-on-click-modal="closeOnClickModal" :before-close="onBeforeClose">
        <div class="m-dialog-content" ref="content"></div>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            /* 
                是否是图片缩略大图展示， 
                功能：
                    1、esc + 点击遮罩层关闭
                    2、不需要背景色
                    3、不要title 和 footer
                    4、不需要顶部关闭按钮
            */
            isImgZoom: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: '确定'
            },
            width: {
                type: String,
                default: '50%'
            },
            fullscreen: {
                type: Boolean,
                default: false
            },
            top: {
                type: String,
                default: '10px'
            },
            modal: {
                type: Boolean,
                default: true
            },
            showClose: {
                type: Boolean,
                default: true
            },
            center: {
                type: Boolean,
                default: false,
            },
            lockScroll: {
                type: Boolean,
                default: true
            },
            closeOnClickModal: {
                type: Boolean,
                default: false
            },
            beforeClose:{
                type: Function
            }
        },
        data(){
            return {
                isShow: false
            }
        },
        mounted(){
            
        },
        methods: {
            onBeforeClose(){
                let vm = this;
                if(vm.beforeClose && typeof(vm.beforeClose) == 'function'){
                    if(vm.beforeClose()){
                        vm.hide();
                    }
                }else{
                    vm.hide();
                }
            },
            show(){
                this.isShow = true;
                let ele = document.activeElement;
                if(ele && ele.nodeName.toLowerCase() == 'button') ele.blur();
                document.body.appendChild(this.$el);
            },
            hide(){
                let vm = this;
                vm.isShow = false;
                setTimeout(function(){
                    document.body.removeChild(this.$el);
                }.bind(vm), 300)
            }
        }
    }
</script>

<style lang="scss" >
    .m-dialog{
        // 缩略图
        &.imgZoom{
            .el-dialog{
                background: none;
                box-shadow: none;
            }
            
        }
        .el-dialog{
            margin-bottom: 10px;
        }
        &.el-dialog__wrapper{
            display: flex;
            justify-content: center;
            align-items: center;
        }
        // 其他弹窗样式
        .el-dialog__body{
            padding: 10px 0 0;
        }
        &-content{
            word-break: break-all;
            .warp{
                margin: 0 10px 10px;
                background-color:#fff;
            }
            .dialog-footer{
                background-color:#fff;
                padding: 20px 0;
                text-align: center;
                .el-button:hover{
                    border-color: #1ab394;
                    color: #1ab394;
                    background: none;
                }
                .el-button.ok{
                    background-color: #1ab394;
                    color: #fff;
                    width: 100px;
                    border: 1px solid #1ab394;
                    &:hover{
                        border: 1px solid #5ecab4;
                        background-color: #5ecab4;
                    }
                }
            }
        }
    }
</style>


